import { Column, ColumnTypes } from 'ui/components/Table/ItemsTable';
import { MenuItem } from 'ui/components/Menu';
import { IconNames } from 'ui/theme';
import { PermissionType } from 'services/permissions';

export const TRANSFER_ORDER_COLUMNS: Column[] = [
  {
    title: 'No.',
    field: 'number',
    sortable: true,
    type: ColumnTypes.string,
    width: 120,
  },
  {
    title: 'Status',
    field: 'status',
    sortable: true,
    type: ColumnTypes.string,
    width: 100,
  },
  {
    title: 'Source',
    field: 'sourceName',
    sortable: true,
    type: ColumnTypes.string,
    width: 150,
  },
  {
    title: 'Destination',
    field: 'destinationName',
    sortable: true,
    type: ColumnTypes.string,
    width: 150,
  },
  {
    title: 'Last Updated',
    field: 'lastUpdated',
    sortable: true,
    type: ColumnTypes.string,
    width: 150,
  },
  {
    title: '',
    width: 50,
    type: ColumnTypes.renderByCustomRow,
  },
];

export enum TransferOrderPageAction {
  AddTransferOrder,
}

export const createTransferOrderActionBarOptions = (
  onActionClick: (actionType: TransferOrderPageAction) => void
): MenuItem[] => [
  {
    label: 'Add Transfer Order',
    onOptionClick: (_ev) =>
      onActionClick(TransferOrderPageAction.AddTransferOrder),
    icon: IconNames.FBOAddCircle,
    permissions: [PermissionType.TransferOrdersCreate],
    dataQa: 'transfer-orders__add-transfer-order',
  },
];

export const createActionBarOptions = (): MenuItem[] => [
  // Empty menu items for now - actions not yet decided
];
